import React, { FC, MouseEvent } from "react";
import { useHistory } from "react-router-dom";
import noop from "lodash/fp/noop";
import { StyledLink } from "./styles";
import { LinkTo } from "../../../globalTypes";
import { OverviewTemplateRouteState } from "../../../utils/internalLinksParsing";
import { Color } from "../../../globalTypes/theme";

const NotificationIndicator: FC<Props> = ({
  notificationCount,
  className,
  linkTo = (location) => location,
  onClick = noop,
  displayWhenZero = false,
  backgroundColor,
}) => {
  const { push } = useHistory();
  if (notificationCount === 0 && !displayWhenZero) return null;

  const valueToDisplay = notificationCount < 1000 ? notificationCount : "999+";

  const handleOnClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();

    if (!linkTo) return;

    if (typeof linkTo !== "function" && typeof linkTo !== "string") {
      const { pathname = "/", state } = linkTo;
      push(pathname, state);
    }

    if (typeof linkTo === "string") {
      push(linkTo);
    }

    onClick();
  };

  return (
    <StyledLink
      notificationCount={notificationCount}
      type="button"
      className={className}
      onClick={handleOnClick}
      backgroundColor={backgroundColor}
      data-cy="notification-indicator"
    >
      <span>{valueToDisplay}</span>
    </StyledLink>
  );
};

export type Props = {
  notificationCount: number;
  className?: string;
  linkTo?: LinkTo<OverviewTemplateRouteState>;
  onClick?: () => void;
  displayWhenZero?: boolean;
  backgroundColor?: Color;
};

export default NotificationIndicator;
export type ControlledProps = Props;
